class EmployeeApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getEmployee({ companyId, employeeId }) {
        return this.fetchService.get(`/companies/${companyId}/employees/${employeeId}`);
    }
}
export default EmployeeApi;
